module.exports = __webpack_public_path__ + "static/media/health.810d149e.jpg";